import { useEffect, useState } from 'react';
import { api, fmtDateTime } from '../api';
import { Loading, Empty, ErrorBox } from '../ui';

const ENTITY_LABEL: Record<string, string> = {
  order: 'Zakaz', customs: 'Rastamojka', product: 'Mahsulot', user: 'Foydalanuvchi',
  receipt: 'Kirim', payment: "To'lov",
};
const ACTION_LABEL: Record<string, { label: string; cls: string }> = {
  create: { label: 'Yaratildi', cls: 'b-received' },
  update: { label: "O'zgartirildi", cls: 'b-confirmed' },
  delete: { label: "O'chirildi", cls: 'b-cancelled' },
};

const compact = (v: any) => {
  if (!v) return '';
  try { const s = JSON.stringify(v); return s.length > 90 ? s.slice(0, 90) + '…' : s; } catch { return String(v); }
};

export default function Audit() {
  const [list, setList] = useState<any[] | null>(null);
  const [entity, setEntity] = useState('');
  const [err, setErr] = useState('');

  const load = () => {
    setList(null);
    setErr('');
    api.get('/audit' + (entity ? '?entity=' + entity : '')).then(setList).catch((e) => setErr(e.message));
  };
  useEffect(load, [entity]);

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Audit jurnali</h1>
          <p className="page-sub">Kim, qachon, nimani o'zgartirgani — oxirgi 200 yozuv</p>
        </div>
      </div>

      <div className="filters">
        <select className="input" style={{ width: 200 }} value={entity} onChange={(e) => setEntity(e.target.value)}>
          <option value="">Barcha obyektlar</option>
          <option value="order">Zakazlar</option>
          <option value="customs">Rastamojka</option>
          <option value="product">Mahsulotlar</option>
          <option value="receipt">Kirimlar</option>
          <option value="payment">To'lovlar</option>
        </select>
      </div>

      {err ? <ErrorBox text={err} onRetry={load} /> : !list ? <Loading /> : list.length === 0 ? (
        <Empty text="Yozuvlar yo'q" hint="Zakaz statusi, rastamojka tasdiqlash va o'chirishlar shu yerda qayd etiladi" />
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Vaqt</th><th>Kim</th><th>Amal</th><th>Obyekt</th><th>Eski → Yangi</th></tr></thead>
            <tbody>
              {list.map((a) => {
                const act = ACTION_LABEL[a.action] || { label: a.action, cls: 'b-draft' };
                return (
                  <tr key={a.id}>
                    <td>{fmtDateTime(a.at)}</td>
                    <td>{a.user?.fullName || a.user?.login || '—'}</td>
                    <td><span className={'badge ' + act.cls}>{act.label}</span></td>
                    <td>{ENTITY_LABEL[a.entity] || a.entity} #{a.entityId}</td>
                    <td style={{ whiteSpace: 'normal', maxWidth: 480, fontSize: 12 }} className="muted">
                      {compact(a.oldData)}{a.oldData && a.newData ? ' → ' : ''}{compact(a.newData)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
